<template>
  <div :id="modalId" :class="modalClass" :gkmodal-color="color">
    <transition name="fade">
      <div gk-modal-mask :class="$style.cover" @click="handleMask" v-if="isLayerShow"></div>
    </transition>
    <transition :name="transition">
      <div gk-modal-main :class="[$style['gk-modal-main']]" v-if="contentShow">
        <span :class="$style.close" gk-modal-close v-if="needClose" @click="handleClose">
          <slot name="close">

          </slot>
        </span>

        <slot name="title">
          <div gk-modal-title :class="$style.title">{{title}}</div>
        </slot>

        <slot />

        <slot name="footer">
          <div gk-modal-footer :class="$style.footer" v-if="needBtn">
            <gkButton gk-modal-cancel :color="cancelBtnColor" :size="btnSize" @click="handleCancel" v-if="needCancelBtn">{{cancelBtnLabel}}</gkButton>
            <gkButton gk-modal-ok :color="okBtnColor" :size="btnSize" :useLock="loading" @click="handleOk">
              <template slot="status" slot-scope="{locked}" >
                <Loading gk-modal-ok-loading :class="$style['gk-modal-ok-loading']" color="white" size="14px" v-if="loading && locked" />
              </template>
              {{okBtnLabel}}
            </gkButton>
          </div>
        </slot>

        <slot name="extra" />
      </div>
    </transition>
  </div>
</template>

<script>

import VueTypes from 'vue-types'
import gkButton from '../../components/button/Button'
import Loading from '../../components/loading'

import modalProps from './modal.props'
export default {
  name: 'gk-modal',
  components: {
    gkButton,
    Loading
  },
  props: {
    ...modalProps,
    value: VueTypes.bool.def(false),
    useLockModal: VueTypes.bool.def(false)
  },
  data () {
    return {
      contentShow: false,
      layerShow: false,
      lockModal: false
    }
  },
  computed: {
    modalId () {
      return `gk-layer${this.id}`
    },
    modalClass () {
      return [
        this.$style['gk-modal'],
        this.$style[`gk-modal-${this.type}`],
        this.$style[`gk-modal-color-${this.color}`]
      ]
    },
    isLayerShow () {
      return this.show || this.layerShow
    }
  },
  created () {
  },
  watch: {
    value (show) {
      if (show) {
        this.showModal()
      } else {
        this.close()
      }
    }
  },
  mounted () {
  },
  beforeDestroy () {
    this.contentShow = false
    this.layerShow = false
  },
  methods: {
    handleOk ({clear}) {
      if (this.loading) {
        // 等待操作结果时，锁定弹框，不允许关闭
        if (this.useLockModal) {
          this.lockModal = true
        }

        this.$emit('ok', {
          clear: () => {
            this.lockModal = false
            clear && clear()
          },
          close: () => {
            this.close()
          }
        })
        return
      }

      this.$emit('ok', {
        clear: () => {
          clear && clear()
        },
        close: () => {
          this.close()
        }
      })

      this.autoClose && this.close()
    },
    handleCancel () {
      this.$emit('cancel')
      this.close()
    },
    handleClose () {
      // 使用loading 配置时，按钮锁定 不应该可以关闭弹窗
      if (this.lockModal) {
        return
      }

      this.$emit('close')
      this.close()
    },
    close () {
      // 内容隐藏
      this.contentShow = false
      // 关闭蒙层
      this.hideLayer()
      this.lockModal = false
      // 通知父组件状态更新
      this.$emit('input', false)
      // 动画做完之后就销毁，组件式调用的话没有效果
      this.destroy()
    },
    handleMask () {
      // 点击遮罩不允许关闭
      if (!this.maskClickClose || this.lockModal) {
        return
      }
      this.close()
    },
    showModal () {
      this.showLayer()
      this.contentShow = true
    },
    showLayer () {
      this.layerShow = true
    },
    hideLayer () {
      this.layerShow = false
    },
    destroy () {
      setTimeout(() => {
        this.$emit('destroy')
      }, 500)
    }
  }
}
</script>
<style lang="scss" module>
.gk-modal {
  position: fixed; z-index: 10000; top: 0; left: 0; right: 0; bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none;
}
.cover {
  position: absolute; top: 0; left: 0; right: 0; bottom: 0; z-index: 10001;
  background: rgba(0, 0, 0, 0.6);
  pointer-events: all;
}
.gk-modal-main {
  position: relative; z-index: 20000;
  background: #fff;
  border-radius: 4px;
  transition: all 0.3s ease;
  pointer-events: all;
}

.close {
  position: absolute; top: 2px; right: 2px;
  width: 30px; height: 30px;
  cursor: pointer;

  &:before,
  &:after {
    content: '';
    position: absolute; top: 50%; left: 50%;
    width: 20px; height: 2px;
    margin-left: -10px;
    background: #8a8a8a;
    border-radius: 2px;
    transform-origin: center;
    transform: rotate(45deg);
  }

  &:after {
    transform: rotate(-45deg);
  }
}

.gk-modal-ok-loading {
  margin-right: 10px;
}

.footer {
  display: flex;
}
</style>
